import { PageId } from 'constants/pages'

export const enum PageIdWoofzNpday75 {
  SUBSCRIPTIONS_NPDAY_75 = PageId.SUBSCRIPTIONS_NPDAY_75,
  CHAT_UPSELL_NPDAY_75 = PageId.CHAT_UPSELL_NPDAY_75,
  UPSELL_NPDAY_75 = PageId.UPSELL_NPDAY_75,
  DOWNLOAD_NPDAY_75 = PageId.DOWNLOAD_NPDAY_75,
  ACCOUNT_NOVE8 = PageId.ACCOUNT_NOVE8,
}
